import { render, staticRenderFns } from "./AppsLayout.vue?vue&type=template&id=9c962ca4&scoped=true"
import script from "./AppsLayout.vue?vue&type=script&lang=js"
export * from "./AppsLayout.vue?vue&type=script&lang=js"
import style0 from "./AppsLayout.vue?vue&type=style&index=0&id=9c962ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c962ca4",
  null
  
)

export default component.exports